(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal.js');
"use strict";



const {
  useState,
  useEffect,
  useCallback,
  useRef
} = React;
const {
  showErrorDialog
} = svs.sport.sport_common;
const {
  Modal,
  cache,
  hooks: {
    useDrawData,
    useRaceData,
    usePixData
  },
  QuickplayModalHeader,
  QuickplayModalMain,
  QuickplayModalFooter
} = svs.components.sport.quickplayModal;

const ErrorSafeQuickplayModal = props => {
  const {
    branding,
    drawNumber,
    productId,
    rowPrice,
    systemCost,
    wallet,
    hasSaveButton,
    isPixMix,
    systemType,
    productSizes,
    competitionBranding
  } = props;
  const {
    handleClose
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => isLoading ? svs.ui.loader.show() : svs.ui.loader.hide(), [isLoading]);
  const hasAlreadyShownErrorRef = useRef(false);
  const _onError = useCallback(message => {
    if (!hasAlreadyShownErrorRef.current) {
      hasAlreadyShownErrorRef.current = true;
      showErrorDialog(null, message, svs.components.dialog.type.DEFAULT);
      handleClose();
    }
  }, [handleClose]);
  const _onDataError = useCallback(() => _onError('Omgången kunde inte hämtas'), [_onError]);
  const _onPixError = useCallback(() => _onError('Kupongen kunde inte hämtas'), [_onError]);

  const drawData = useDrawData({
    productId,
    drawNumber,
    onError: _onDataError
  });
  const raceData = useRaceData({
    productId,
    drawNumber,
    onError: _onDataError
  });
  const pixData = usePixData({
    drawData,
    isPixMix,
    onError: _onPixError,
    productId,
    raceData,
    rowPrice,
    systemCost,
    systemType
  });
  const [hasSuccessfullyLoadedPixOnce, setHasAlreadyLoadedPixOnce] = useState(false);
  useEffect(() => {
    if (pixData && !hasSuccessfullyLoadedPixOnce) {
      setHasAlreadyLoadedPixOnce(true);
    }
  }, [pixData, hasSuccessfullyLoadedPixOnce]);
  const hasData = Boolean((drawData === null || drawData === void 0 ? void 0 : drawData.drawNumber) || (raceData === null || raceData === void 0 ? void 0 : raceData.drawNumber));
  useEffect(() => {
    if (hasData && pixData) {
      cache.setKeepOpen({
        branding,
        productId,
        drawNumber,
        hasSaveButton,
        systemCost,
        systemType,
        rowPrice,
        productSizes: productSizes.join(',')
      });
    } else {
      cache.unsetKeepOpen();
    }
  }, [hasData, pixData, branding, productId, drawNumber, hasSaveButton, systemCost, systemType, rowPrice, productSizes]);
  if (!hasData || !hasSuccessfullyLoadedPixOnce) {
    return null;
  }
  if (isLoading) {
    setIsLoading(false);
  }
  return React.createElement("div", {
    className: "quickplay-modal quickplay-modal-branding-".concat(branding, " fc-white")
  }, React.createElement(QuickplayModalHeader, {
    handleClose: handleClose,
    productId: productId
  }), React.createElement(QuickplayModalMain, {
    branding: branding,
    drawData: drawData,
    isPixMix: isPixMix,
    onPixError: _onPixError,
    pixData: pixData,
    productId: productId,
    productSizes: productSizes,
    raceData: raceData,
    rowPrice: rowPrice,
    systemCost: systemCost,
    systemType: systemType
  }), React.createElement(QuickplayModalFooter, {
    competitionBranding: competitionBranding,
    drawData: drawData,
    handleClose: handleClose,
    hasSaveButton: hasSaveButton,
    pixData: pixData,
    productId: productId,
    raceData: raceData,
    rowPrice: rowPrice,
    systemCost: systemCost,
    systemType: systemType,
    wallet: wallet
  }));
};
const QuickplayModal = props => {
  const {
    branding,
    productId,
    drawNumber,
    systemCost,
    rowPrice,
    wallet,
    onModalClose,
    hasPortal,
    hasSaveButton,
    isPixMix,
    systemType,
    productSizes,
    competitionBranding
  } = props;
  const [isStillOpen, setIsStillOpen] = useState(true);
  const handleClose = useCallback(() => {
    cache.unsetKeepOpen();
    svs.ui.loader.hide();
    setIsStillOpen(false);
    if (onModalClose) {
      onModalClose();
    }
  }, [onModalClose]);
  if (!isStillOpen) {
    return null;
  }
  return React.createElement(Modal, {
    ariaLabel: "PIX widget",
    handleCloseModal: handleClose,
    hasPortal: hasPortal,
    initialFocusSelector: ".initial-focus",
    isClosingOnBackgroundClick: true
  }, React.createElement(ErrorSafeQuickplayModal, {
    branding: branding,
    competitionBranding: competitionBranding,
    drawNumber: drawNumber,
    handleClose: handleClose,
    hasSaveButton: hasSaveButton,
    isPixMix: isPixMix,
    productId: productId,
    productSizes: productSizes,
    rowPrice: rowPrice,
    systemCost: systemCost,
    systemType: systemType,
    wallet: wallet
  }));
};
QuickplayModal.defaultProps = {
  hasPortal: false,
  hasSaveButton: false,
  isPixMix: false,
  productSizes: [],
  rowPrice: 1,
  wallet: null
};
setGlobal('svs.components.sport.quickplayModal.QuickplayModal', QuickplayModal);

 })(window);